module.exports = __webpack_public_path__ + "img/house-building.6b7c40a4.svg";